import styled from 'styled-components';

const ImageThreadItem = styled.img`
  vertical-align: middle;
  width: 35px;
  height: 35px;
  border-radius: 50%;
`;

export default ImageThreadItem;
